import React, { useEffect, useState } from "react";
import PersonList from "../components/PersonList";

export function StudentList() {
  const [childList, setChildList] = useState([]);

  useEffect(() => {
    let childs = localStorage.getItem("CHILDS");
    childs =
      childs && childs.length > 1 ? childs.substring(0, childs.length - 2) : "";
    setChildList(JSON.parse(`[${childs}]`));
  }, []);

  return (
    <div className="container my-3 py-5">
      <main className="mt-5">
        <h3 className="fw-light pb-2">
          <i className="bi bi-person-vcard"></i> Alunos
        </h3>
        {childList && childList.length > 0 ? (
          <ul>
            <PersonList persons={childList}></PersonList>
          </ul>
        ) : (
          "Nenhum dado cadastrado..."
        )}
      </main>
    </div>
  );
}
